module.exports = __webpack_public_path__ + "img/rosemount-2160-wireless-detector-vibrating-fork-facing-right.cb922911.png";